module.exports = __webpack_public_path__ + "img/slp_pendle_eth.0ef3e3b1.svg";